import { Navigate, Route, Routes } from "react-router-dom";
import FSIPage from "./fsi";
import OrdersPage from "./orders";
import ProductsPage from "./products";

const IncPages = () => (
  <Routes>
    <Route>
      <Route path="orders" element={<OrdersPage />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="fsi" element={<FSIPage />} />
      <Route path="*" element={<Navigate to="orders" />} />
    </Route>
  </Routes>
);

export default IncPages;
